export function is(role, roles) {
    if(typeof roles === 'object') {
        for(let key in roles) {
            if(roles[key]["guard_name"] === role)
                return true
        }
    }
    return false;
}